import 'ng-idle';
import 'angular-utils-pagination';
import 'factory/consts';
import 'factory/REST';
import 'factory/util';
import 'factory/showXML';

angular.module('TInv.ctrl.Lista', [
    'ngIdle',
    'angularUtils.directives.dirPagination',
    'TInv.consts',
    'TInv.REST',
    'TInv.alert',
    'TInv.util',
    'TInv.showXML',
]).controller('ListaCtrl', function ($log, $scope, $uibModal, revision, x2js, Consts, REST, FileUtil, Idle, pollingFactory, alert, delayed, showXML) {
    $scope.fatture = [];
    
    $scope.spinner = {};
    $scope.spinner.loading = true;
    
    $scope.tipiDocumento = Consts.tipiDocumento;
    $scope.refreshLog = new Date(0);
    $scope.checkList = true;
    $scope.orderByField = 'DataOraCreazione';
    $scope.reverseSort = true;
    
    $scope.advancedSearch = false;

    $scope.printDate = function(){
        $log.debug($scope.filtro.dateFrom);
    };
    
    $scope.filtro = {};

    $scope.filtro.clear = function () {
        var filterDate = new Date();
        filterDate.setDate(filterDate.getDate()-31);
        $scope.filtro.query = '';
        $scope.filtro.dateFrom = filterDate.toISOString();
        $scope.filtro.dateTo = null;
    };
    
    //$scope.updateClients($scope.selected.client.IdCodice, false);

    $scope.activateAdvancedSearch = function(){
        $scope.advancedSearch = !$scope.advancedSearch;
    };
    
    $scope.changedCedente = function(){
        $log.debug($scope.selected.client);
        $scope.filtro.clear();
        $scope.spinner.loading = true;
        $scope.fatture = [];
        $scope.sleep(100);
        $scope.list();
    };
    
    $scope.filtro.clear();
    
    $scope.sleep = function(delay){
        //$log.debug('sleeping...');
        var start = new Date().getTime();
        while (new Date().getTime() < start + delay);
    };
    $scope.list = delayed(500, function () {
        if ($scope.state != 'list-att')
            return; // don't update if not on screen
        $scope.spinner.loading = true;
        REST.list($scope.login.cedente, $scope.login.pass
        ).then(function (f) {
            //$log.debug('Fatture attive', f);
            $scope.fatture = f;
            $scope.refreshLog = new Date();
        }).catch(function (err) {
            $log.debug('Fatture attive', err);
            $scope.fatture = [];
            $scope.fatture.err = true;
        }).finally(function(){
            $scope.spinner.loading = false;
        }); 
    });
    $scope.$watch('filtro.dateFrom + filtro.dateTo + filtro.query', function () {
        $scope.spinner.loading = true;
        $scope.fatture = [];
        $scope.sleep(100);
        $scope.list();
    });
    $scope.$on('refresh', function () {
        $scope.list();
    });
    Idle.watch();
    pollingFactory.callFnOnInterval(function (){
        if($scope.checkList == true)
            $scope.list();
    });
    $scope.$on('IdleStart', function() {
        $log.debug('Starting idle state.');
        $scope.checkList= false;
    });
    $scope.$on('IdleTimeout', function() {
        //TODO: Nothing to do when Idle  
        $log.debug('idle timeout state.');
    });
    $scope.$on('IdleEnd', function() {
        $log.debug('Reset idle state.');
        $scope.list();
        $log.debug('Refresh Done...');
        $scope.checkList = true;
    });
    
    $scope.downloadFileXML = function (fname) {
        $log.debug('Download file XML');
        $scope.error = null;
        REST.download($scope.login.cedente, $scope.login.pass, fname
        ).then(function(xml) {
            FileUtil.saveXML(xml, fname);
        }).catch(alert.error);
    };
    $scope.downloadZip = function (progressivoInvio) {
        $scope.error = null;
        if($scope.login.cedente === $scope.selected.client.IdCodice)
            REST.downloadZip($scope.login.cedente, $scope.login.pass, null, progressivoInvio
            ).then(function (zip) {
                FileUtil.saveWSDL(zip, 'application/zip');
            }).catch(alert.error);
        else{
            REST.downloadZip($scope.login.cedente, $scope.login.pass, $scope.selected.client.IdCodice, progressivoInvio
            ).then(function (zip) {
                FileUtil.saveWSDL(zip, 'application/zip');
            }).catch(alert.error);
        }
    };

    $scope.refuseMessage = function (fname) {
        var parent = $scope;
        $uibModal.open({
            templateUrl: 'template/refuseMessage.html?rev=' + revision,
            controller: function ($scope, $uibModalInstance) {
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.refuse = function () {
                    parent.refuseBilling(fname, $scope.refuseString);
                    $uibModalInstance.close();
                };
            },
        });
    };

    $scope.acceptBilling = function (fname) {
        $scope.error = null;
        $scope.receivedBill = true;
        return REST.download($scope.login.cedente, $scope.login.pass, fname
        ).then(function(xml) {
            //$log.debug('Invoice preload: ', xml);
            var data = x2js.xml_str2json(xml);
            data = data.FatturaElettronica;
            $log.debug('Sending:', data);
            return $scope.sendXML(fname, data.FatturaElettronicaHeader.DatiTrasmissione.PECDestinatario || data.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario, data.FatturaElettronicaHeader.CessionarioCommittente, data.FatturaElettronicaBody);
        }).catch(alert.error);
    };

    $scope.refuseBilling = function (fname, descrizione) {
        $scope.error = null;
        $scope.receivedBill = true;
        REST.refuse($scope.login.cedente, $scope.login.pass, fname, descrizione
        ).then(function (){
            $scope.list();
        }).catch(alert.error);
    };

    $scope.showFatt = function (fname) {
        $log.debug('ShowFatt');
        var fnAccept = null;
        fnAccept = function (accepted) {
            if (accepted)
                $scope.acceptBilling(fname);
            else
                $scope.refuseMessage(fname);
        };
        showXML(1, REST.download($scope.login.cedente, $scope.login.pass, fname), fnAccept);
    };

    $scope.editInvoice = function (fname) {
        REST.download($scope.login.cedente, $scope.login.pass, fname
        ).then(function(xml) {
            $log.debug('Invoice preload: ', xml);
            $scope.fatturaForm.xml = xml;
            $scope.fatturaForm.name = fname;
            $scope.setState('create');
        }).catch(alert.error);
    };
}).config(function(IdleProvider, KeepaliveProvider) {
    IdleProvider.idle(120);
    //IdleProvider.timeout(6000);
    KeepaliveProvider.interval(4);
});
